import {Component} from '@angular/core';


@Component({
  selector: 'app-message-field',
  imports: [],
  templateUrl: './message-field.component.html',
  standalone: true
})
export class MessageFieldComponent {
  message: string = null
  severity = 'cl-alert-info';
  currentTimeout: any = null;
  public setMessage(message: string,
                    severity: 'cl-alert-danger' | 'cl-alert-warning' | 'cl-alert-info',
                    duration: number) {
    this.message = message;
    this.severity = severity
    console.log('Severity: ', severity);
    console.log('Duration: ', duration);
    if (this.currentTimeout) {
      clearTimeout(this.currentTimeout);
      this.currentTimeout = null;
    }
    if (duration >= 0) {
      console.log('triggering timeout');
      this.currentTimeout = setTimeout(() => {
        this.message = null;
        this.currentTimeout = null;
      }, duration)
    }
  }
}
